<template>
  <div class="pv_home">
    <div class="wh-card" v-if="pvHomeConfig.type === 'adv_list'">
      <WHomeBanner :data="pvHomeConfig.value" track-home-banner-source />
    </div>
    <!-- 金刚区Icon -->
    <div class="wh-card" v-if="pvHomeConfig.type === 'icon_list' && pvHomeConfig.value.item?.length > 0">
      <WHomeIconList :data="pvHomeConfig.value.item" track-home-icon-source />
    </div>
      <!-- 秒杀 -->
    <div class="wh-card" v-if="pvHomeConfig.type === 'flash_sale'">
      <WHomeFlashSale />
    </div>

    <div class="wh-card" v-if="pvHomeConfig.type === 'cut_image'">
      <WHomeCutImage :data="pvHomeConfig.value" track-home-banner-source />
    </div>

    <div class="wh-card" v-if="pvHomeConfig.type === 'new_arrival'">
      <WHNewArrival :productList="newArrivalMock || []" />
    </div>
  </div>
</template>

<script setup lang="ts">
import WHomeBanner from './wap-widgets/Banner.vue';
import WHomeIconList from './wap-widgets/IconList.vue'
import WHomeCutImage from './wap-widgets/CutImage.vue'
import WHomeFlashSale from './wap-widgets/FlashSale.vue'
import WHNewArrival from './wap-widgets/NewArrival.vue'
import { Base64 } from 'js-base64'

const pvHomeConfig = ref<any>([])
const back_height_fn = (data_arr: Array<string>): void => {
  let h: number = document.body.scrollHeight;
  window.parent.postMessage(data_arr[0].replace('kilimall', '') + '|' + h, "*");
  setTimeout(() =>{
    back_height_fn(data_arr);
  }, 3000)
}

const newArrivalMock = [
  {
    listingId: 1000100657,
    minListPrice: 1188,
    maxListPrice: 0,
    image: "https://mkp-cn-testing.obs.cn-south-1.myhuaweicloud.com/c/test/public/store/100000019/goods/image/100101859.jpg?x-image-process=image/format,webp/resize,w_360#",
    title: "jacob11122 testadf23erw"
  },
  {
    listingId: 1000100805,
    minListPrice: 4,
    maxListPrice: 0,
    image: "https://mkp-cn-testing.obs.cn-south-1.myhuaweicloud.com/c/test/public/store/100000310/goods/image/100102277.png?x-image-process=image/format,webp/resize,w_360#",
    title: "test copy and edit"
  },
  {
    listingId: 1000100848,
    minListPrice: 1,
    maxListPrice: 0,
    image: "https://mkp-cn-testing.obs.cn-south-1.myhuaweicloud.com/c/test/public/store/100000310/goods/image/100102362.jpg?x-image-process=image/format,webp/resize,w_360#",
    title: "test fjjrgjergwg"
  },
  {
    listingId: 1000100828,
    minListPrice: 5,
    maxListPrice: 0,
    image: "https://mkp-cn-testing.obs.cn-south-1.myhuaweicloud.com/c/test/public/store/100000310/goods/image/100102339.png?x-image-process=image/format,webp/resize,w_360#",
    title: "TYUTRYU"
  }
]

const mounted = () => {
  window.addEventListener('message',function(event){
    if(typeof(event.data) !== 'string' || event.data.indexOf('kilimall') < 0) return

    const jsonData = event.data.split('|')
    
    if(jsonData.length < 2) { return }
    
    const data = jsonData[1]
    const configItems = JSON.parse(Base64.decode(data))

    configItems.forEach((c: any) => {
      const [key] = Object.keys(c)
      pvHomeConfig.value = {
        type: key,
        value: c[key]
      }
    })

    back_height_fn(jsonData)
  }, false)
}

onMounted(mounted)
</script>

<style lang="scss" scoped>
.pv_home{
  background-color: #F5F5F5;
  min-height: 100vh;
  box-sizing: border-box;
  padding: 6px 10px;
}
</style>